import { useEffect } from 'react';
import useRouter from 'use-react-router';
import { StaticContext } from 'react-router';
import { useSelector } from 'react-redux';
import { getDeviceInfo } from './use-device-info';
import { selectSessionSelector } from '@mm/state/selectors/userSelector';
import { useUsersCRUDActions } from '@mm/state/actions/UsersCRUDActions';
import { StoreState } from '@mm/state/store-interfaces';

export type UseOpenAppOrStorePage = () => void;
type LocationState = { openStore: boolean } | undefined;

export const useOpenAppOrStorePage: UseOpenAppOrStorePage =
  (): ReturnType<UseOpenAppOrStorePage> => {
    const { isAndroid, isIOS } = getDeviceInfo();
    const { location } = useRouter<{}, StaticContext, LocationState>();
    const { userAttributes, id: userId } = useSelector(selectSessionSelector);
    const { updateUserAttributes } = useUsersCRUDActions();
    const appNavigationHistory = useSelector(
      (state: StoreState) => state.view.appNavigationHistory,
    );
    useEffect(() => {
      if (location.state?.openStore || !appNavigationHistory.length) {
        if (
          (isAndroid || isIOS) &&
          userAttributes &&
          userAttributes.activeCompanyId
        ) {
          const signInDeeplink =
            `${location.pathname}${location.search}`.substring(1);
          updateUserAttributes(userAttributes.activeCompanyId, userId, {
            signInDeeplink,
          });
        }
        if (isAndroid) {
          window.location.replace(
            'https://play.google.com/store/apps/details?id=com.mobilemonkey',
          );
        }

        if (isIOS) {
          window.location.replace(
            'https://apps.apple.com/app/mobilemonkey-chat/id1481948082',
          );
        }
      }
    }, [isAndroid, isIOS]);
  };
